import OutlineFormattedTextField from './OutlineFormattedTextField';
export default OutlineFormattedTextField;